(function()
{
	//Import classes
	var BasePanel = include('springroll.easeljs.BasePanel'),
		Container = include('createjs.Container'),
		Cutscene = include('PrimalSpringroll.Cutscene');

	/**
	 * Panel contains all of the visual elements for the Game state
	 * @class Lemonade.OutroPanel
	 * @extends springroll.easeljs.BasePanel
	 */
	var OutroPanel = function()
	{
		BasePanel.call(this);

		this.playAnimationSequence = this.playAnimationSequence.bind(this);
		this.showThoughtBubble = this.showThoughtBubble.bind(this);
		this.showIdea = this.showIdea.bind(this);
		this.hideThoughtBubble = this.hideThoughtBubble.bind(this);
	};

	//Super prototype
	var s = BasePanel.prototype;

	//Extend the base panel
	var p = extend(OutroPanel, BasePanel);

	/**
	 * Setup the state, this happens on each state entering
	 */
	p.setup = function()
	{
		this.state = app.states.outro;
		/**
		 * The constructed game stage
		 * @property {createjs.Container} skin
		 */

		this.sceneLib = app.globalState.language == "en" ? lib_outro : lib_outro_es;
		this.skin = new this.sceneLib[app.globalState.language == "en" ? "Outro" : "Outro_sp"]();
		this.skin._updateTimeline();
		this.addChild(this.skin);

		// Setup characters
		this.grover = this.skin.grover;
		this.grover.framerate = 31;
		this.grover.stop();

		this.elmo = this.skin.elmo;
		this.elmo.framerate = 31;
		this.elmo.stop();

		this.thoughtBubble = this.skin.thought_bubble;
		this.thoughtBubble.framerate = 31;
		this.thoughtBubble.stop();

		this.cause = this.thoughtBubble.cause_pics;
		this.cause.framerate = 31;
		this.cause.gloryrays.framerate = 31;
		this.cause.stop();

		// Animation sequence settings
		this.activeChar = this.grover;
		this.sequenceStage = -1;
		this.outroSequence = [
			{
				char: "Grover",
				anim: "Outro_1"
			},
			{
				char: "Grover",
				anim: app.globalState.causes[app.globalState.currentCause].outro,
				onPlay: this.showThoughtBubble
			},
			{
				char: "Grover",
				anim: "Thanks_1"
			},
			{
				char: "Elmo",
				anim: "Thanks_2"
			}
		];
	};

	p.playAnimationSequence = function() {
		this.sequenceStage++;
		if (this.sequenceStage >= this.outroSequence.length) {
			this.onAnimationComplete();
			return;
		}

		var nextAnim = this.outroSequence[this.sequenceStage];
		if (nextAnim.char == "Grover") {
			this.activeChar = this.grover;
			app.animator.play(this.elmo, "idle");
		} else {
			this.activeChar = this.elmo;
		}

		app.animator.play(
			this.activeChar,
			this.config.animations[nextAnim.char][nextAnim.anim],
			this.playAnimationSequence
		);

		if (typeof nextAnim.onPlay == "function") {
			nextAnim.onPlay();
		}

		// if (typeof nextAnim.onPlay == "function") {
		// 	nextAnim.onPlay();
		// }
	};

	p.onAnimationComplete = function() {
		this.state.nextState();
	};

	p.showThoughtBubble = function() {
		// add delay here
		createjs.Tween.get(this)
			.call(function(){
				app.animator.play(
					this.thoughtBubble,
					"appear",
					this.showIdea
				);
				app.sound.play("ses-lem_thoughtbubble-on");
			}.bind(this));
		
	};

	p.showIdea = function() {
		app.animator.play(
			this.cause,
			app.globalState.causes[app.globalState.currentCause].item_name,
			this.hideThoughtBubble
		);
		app.sound.play("ses-lem_plant-hiliteloop");
	};

	p.hideThoughtBubble = function() {
		// add delay here
		createjs.Tween.get(this)
			.wait(4000)
			.call(function(){
				app.animator.play(
					this.thoughtBubble,
					"disappear"
				);
				app.sound.stop("ses-lem_plant-hiliteloop");
				app.sound.play("ses-lem_thoughtbubble-off");
			}.bind(this));
		
	};

	/**
	 * Un-setup the panel when exiting the state
	 */
	p.teardown = function()
	{
		app.animator.stopAll();
		s.teardown.call(this);
	};

	//Assign to namespace
	namespace('Lemonade').OutroPanel = OutroPanel;
}());